export var itemGridColumn = 'html-email-item-grid-column';
export var itemGridSpacer = 'html-email-item-grid-spacer';
//# sourceMappingURL=css-classes.js.map